
import { Component, Vue } from 'vue-property-decorator'
import Header from './Header.vue'
import BottomBtn from './BottomBtn.vue'
@Component({
    name: 'IndexPage',
    components: {
        Header,
        BottomBtn
    }
})
export default class extends Vue {
    private isScroll = false
    private handleScroll () {
        let scrollTop = document.documentElement.scrollTop
        this.isScroll = scrollTop > 0
    }
	mounted () {
    	window.addEventListener('scroll', this.handleScroll)
    } 
    beforeDestroy () {
        window.removeEventListener('scroll', this.handleScroll)
    }
}
